import React from 'react';
import { Typography } from '@mui/material';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  span?: number;
}

/**
 * Helper component for rendering label-value pairs in a grid layout.
 * Used in report components to display structured data.
 */
const DetailRow: React.FC<DetailRowProps> = ({ label, value, span }) => (
  <>
    <Typography variant="body2" fontWeight={600}>{label}</Typography>
    <Typography variant="body2" sx={span ? { gridColumn: `span ${span}` } : undefined}>
      {value}
    </Typography>
  </>
);

export default DetailRow;